// START constants
export const DIRECTIONS = {
  scratch: 'Scratch',
  python: 'Python',
  javaScript: 'JavaScript',
  java: 'Java',
  minecraft: 'Minecraft',
  roblox: 'Roblox',
  C: 'C++',
  coSpaces: 'CoSpaces',
};

export const FORMATS = {
  beginner: 'nachinayushchim',
  advanced: 'prodvinutym',
  tutor: 'repetitor',
};
// END constants

// START list
export const directionsList = [
  { id: 'all', title: 'Все направления' },
  { id: DIRECTIONS.scratch, title: DIRECTIONS.scratch, pretext: 'в' },
  { id: DIRECTIONS.python, title: DIRECTIONS.python, pretext: 'на' },
  { id: DIRECTIONS.javaScript, title: DIRECTIONS.javaScript, pretext: 'на' },
  { id: DIRECTIONS.java, title: DIRECTIONS.java, pretext: 'на' },
  { id: DIRECTIONS.minecraft, title: DIRECTIONS.minecraft, pretext: 'в' },
  { id: DIRECTIONS.roblox, title: DIRECTIONS.roblox, pretext: 'в' },
  { id: DIRECTIONS.C, title: DIRECTIONS.C, pretext: 'на' },
  { id: DIRECTIONS.coSpaces, title: DIRECTIONS.coSpaces, pretext: 'в' },
];

export const formatsList = [
  { id: 'all', title: 'Все форматы' },
  { id: FORMATS.beginner, title: 'Начинающий', forTitle: ', для начинающих' },
  { id: FORMATS.advanced, title: 'Продвинутый', forTitle: ', для продвинутых' },
  { id: FORMATS.tutor, title: 'Репетиторы', forTitle: ' с репетитором' },
];
// END list

export const cards = [
  {
    direction: DIRECTIONS.scratch,
    format: FORMATS.beginner,
    title: 'Scratch Elementary',
    for: 'для начинающих',
    image: 'scratch',
    price: 12000,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'Анимация', colored: true },
      { text: 'Игры', colored: true },
    ],
    textItems: [
      'Визуальный язык программирования для начинающих',
      'Познакомитесь с основами и будете ориентироваться в&nbsp;среде',
      'Начнете разрабатывать своих персонажей для будущих мультфильмов',
      'Будете составлять первые алгоритмы, тестировать программы и изменять их',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.beginner,
    title: 'Python Elementary',
    for: 'для начинающих',
    image: 'python',
    price: 14000,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'ИИ', colored: true },
      { text: 'Игры', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Универсальный и легкий язык программирования',
      'Подходит для тех, кто хочет начать программировать и&nbsp;попробовать навыки в разных областях',
      'Погружение с нуля и освоение базовых знаний в&nbsp;игровой форме',
      'Написание кода и программ на Python',
      'Практика использования облачной среды разработки',
    ],
  },
  {
    direction: DIRECTIONS.roblox,
    format: FORMATS.beginner,
    title: 'Roblox Basic',
    for: 'для начинающих',
    image: 'roblox',
    price: 12000,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'Игры', colored: true },
      { text: 'Виртуальные миры', colored: true },
    ],
    textItems: [
      'Платформа для создания игр',
      'Подходит тем, кто хочет научиться создавать игры&nbsp;с&nbsp;нуля',
      'Будете ориентироваться в платформе, писать скрипты на языке Lua, освоите важные понятия и навыки',
      'Разработаете полноценный платформер с квестами, ловушками, NPC и пр.',
    ],
  },
  {
    direction: DIRECTIONS.minecraft,
    format: FORMATS.beginner,
    title: 'Minecraft Elementary',
    for: 'для начинающих',
    image: 'minecraft',
    price: 12000,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'Игры', colored: true },
    ],
    textItems: [
      'Создание и изменение миров Minecraft',
      'Идеально для тех, кто любит Minecraft и хочет научиться программировать',
      // eslint-disable-next-line max-len,vue/max-len
      'Познакомитесь с Minecraft Education Edition (агент и&nbsp;команды управления, массивы мобов, циклы, блоки событий)',
      'Создадите игровые элементы: башню, замок, фонтан, – и многое другое',
    ],
  },
  {
    direction: DIRECTIONS.coSpaces,
    format: FORMATS.beginner,
    title: 'CoSpaces Elementary ',
    for: 'для начинающих',
    image: 'coSpaces',
    price: 12000,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'AR/VR', colored: true },
    ],
    textItems: [
      'Платформа для создания виртуальной реальности (VR) и дополненной реальности (AR)',
      'Познакомитесь с инструментами 3D-моделирования',
      'Научитесь создавать собственные 3D-миры, управлять моделями и анимировать их',
      'Разовьете пространственное мышление и&nbsp;воображение',
    ],
  },

  {
    direction: DIRECTIONS.python,
    format: FORMATS.beginner,
    title: 'Python 3D-игры',
    for: 'для начинающих',
    image: 'python',
    price: 12000,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: '3D', colored: true },
      { text: 'Игры', colored: true },
    ],
    textItems: [
      'Универсальный и легкий язык программирования',
      'Работа с 3D-графикой, интеграция звуковых эффектов, разработка игровых сценариев',
      'Тестирование сценариев игры',
      'Создание интерактивных 3D-объектов',
      'Оптимизация кода',
    ],
  },
  {
    direction: DIRECTIONS.javaScript,
    format: FORMATS.beginner,
    title: 'JavaScript Start',
    for: 'для начинающих',
    image: 'javaScript',
    price: 24285,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'Веб-анимация', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Язык программирования для создания интерактивных элементов на сайте',
      'Подходим тем, кто хочет стать веб-разработчиком',
      'Научитесь верстке сайтов с помощью HTML и CSS',
      'Освоите основы JavaScript и Figma ',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.beginner,
    title: 'Python Start',
    for: 'для начинающих',
    image: 'python',
    price: 24285,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'ИИ', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Универсальный и легкий язык программирования',
      'Подходит для тех, кто хочет начать программировать и&nbsp;попробовать навыки в разных областях',
      'Узнаете про синтаксис языка программирования Python',
      'Начнете работать с объектноориентированным программированием',
    ],
  },
  {
    direction: DIRECTIONS.java,
    format: FORMATS.beginner,
    title: 'Java Start',
    for: 'для начинающих',
    image: 'java',
    price: 24285,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'Программы', colored: true },
      { text: 'Сайты', colored: true },
      { text: 'Мобильные приложения', colored: true },
    ],
    textItems: [
      'Язык программирования для разработки приложений, платформ и программ',
      'Вы&nbsp;познакомитесь с&nbsp;синтаксисом языка Java, узнаете о&nbsp;циклах и&nbsp;массивах',
      'Освоите основы объектно-ориентированного программирования и наследования',
    ],
  },
  {
    direction: DIRECTIONS.C,
    format: FORMATS.beginner,
    title: 'С++ Start',
    for: 'для начинающих',
    image: 'cplus',
    price: 24285,
    cheap: [
      { text: '3 месяца', colored: false },
      { text: 'Программы', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Linux', colored: true },
      { text: 'SQL', colored: true },
    ],
    textItems: [
      'Мощный язык программирования, используемый для создания высокопроизводительных приложений',
      'Научитесь программировать на языке C++ и решать математические задачи',
      'Создадите веб-приложение',
      'Научитесь анализировать данные, работать с языком запросов SQL и системой Linux',
    ],
  },

  {
    direction: DIRECTIONS.javaScript,
    format: FORMATS.beginner,
    title: 'JavaScript Basic',
    for: 'для начинающих',
    image: 'javaScript',
    price: 48570,
    cheap: [
      { text: '6 месяцев', colored: false },
      { text: 'Веб-анимация', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Язык программирования для создания интерактивных элементов на сайте',
      'Погрузитесь в синтаксис языка JavaScript',
      'Познакомитесь с серверной платформой Node.js для работы с JavaScript',
      'Узнаете особенности объектноориентированного программирования в JavaScript',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.beginner,
    title: 'Python Basic',
    for: 'для начинающих',
    image: 'python',
    price: 48570,
    cheap: [
      { text: '6 месяцев', colored: false },
      { text: 'ИИ', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Универсальный и легкий язык программирования',
      'Научитесь использовать функционал фреймворка Django',
      'Узнаете основы создания дизайна web-приложения',
      'Разработаете динамическое web-приложение с&nbsp;публикациями',
    ],
  },
  {
    direction: DIRECTIONS.java,
    format: FORMATS.beginner,
    title: 'Java Basic',
    for: 'для начинающих',
    image: 'java',
    price: 48570,
    cheap: [
      { text: '6 месяцев', colored: false },
      { text: 'Программы', colored: true },
      { text: 'Мобильные приложения', colored: true },
    ],
    textItems: [
      'Язык программирования для разработки приложений, платформ и программ',
      'Узнаете об&nbsp;интерфейсах и&nbsp;структурах, освоите классы и&nbsp;методы',
      // eslint-disable-next-line max-len,vue/max-len
      'Научитесь работать с&nbsp;интерфейсами API и&nbsp;UI, которые отвечают за&nbsp;взаимодействие между&nbsp;пользователями и&nbsp;компьютерными приложениями',
    ],
  },
  {
    direction: DIRECTIONS.C,
    format: FORMATS.beginner,
    title: 'С++ Basic',
    for: 'для начинающих',
    image: 'cplus',
    price: 48570,
    cheap: [
      { text: '6 месяцев', colored: false },
      { text: 'Программы', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Linux', colored: true },
      { text: 'SQL', colored: true },
    ],
    textItems: [
      'Мощный язык программирования, используемый для создания высокопроизводительных приложений',
      'Более углубленно освоите разработку на С++',
      'Научитесь работать с&nbsp;языком запросов SQL и&nbsp;использовать на&nbsp;практике систему контроля версий Git',
    ],
  },

  {
    direction: DIRECTIONS.scratch,
    format: FORMATS.beginner,
    title: 'Scratch Upgrade',
    for: 'для начинающих',
    image: 'scratch',
    price: 24000,
    cheap: [
      { text: '6 месяцев', colored: false },
      { text: 'Анимация', colored: true },
      { text: 'Игры', colored: true },
    ],
    textItems: [
      'Визуальный язык программирования для начинающих',
      'Научитесь создавать и применять продвинутые алгоритмы, условия и циклы для создания персонажей и управления ими',
      'Будете использовать координаты, благодаря которым сможете создать собственную игру',
    ],
  },
  {
    direction: DIRECTIONS.roblox,
    format: FORMATS.beginner,
    title: 'Roblox Upgrade',
    for: 'для начинающих',
    image: 'roblox',
    price: 24000,
    cheap: [
      { text: '6 месяцев', colored: false },
      { text: 'Игры', colored: true },
      { text: 'Виртуальные миры', colored: true },
    ],
    textItems: [
      'Платформа для создания игр',
      'Научитесь составлять пошаговые планы для разработки игры, задавать свойства объектам',
      'Создадите игровых персонажей, сложные объекты, огнестрельное оружие',
      'Будете работать со списками данных и применять математические операции',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.beginner,
    title: 'Python Upgrade',
    for: 'для начинающих',
    image: 'python',
    price: 28000,
    cheap: [
      { text: '6 месяцев', colored: false },
      { text: 'ИИ', colored: true },
      { text: 'Игры', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Универсальный и легкий язык программирования',
      'Научитесь навыкам создания и оформления сайтов (HTML и CSS)',
      'Ознакомитесь с базами данных, запустите сервер с&nbsp;помощью фреймворка Flask и др.',
      'Освоите работу с циклами, условиями и фильтрами Jinja, а также обработку данных из форм',
    ],
  },

  {
    direction: DIRECTIONS.javaScript,
    format: FORMATS.advanced,
    title: 'JavaScript Upgrade',
    for: 'для продвинутых',
    image: 'javaScript',
    price: 72855,
    cheap: [
      { text: '9 месяцев', colored: false },
      { text: 'Веб-анимация', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Язык программирования для создания интерактивных элементов на сайте',
      'Научитесь работать с системой контроля версий Git',
      'Разберетесь с фреймфорками, как с ними работать',
      'Освоите основные компоненты в таблице стилей CSS',
    ],
  },
  {
    direction: DIRECTIONS.java,
    format: FORMATS.advanced,
    title: 'Java Upgrade',
    for: 'для продвинутых',
    image: 'java',
    price: 72855,
    cheap: [
      { text: '9 месяцев', colored: false },
      { text: 'Программы', colored: true },
      { text: 'Мобильные приложения', colored: true },
    ],
    textItems: [
      'Язык программирования для разработки приложений, платформ и программ',
      'Познакомитесь с базами данных и системой контроля версий GIT',
      'Узнаете, что такое функциональное программирование',
      'Научитесь работать с фреймворком Spring',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.advanced,
    title: 'Python Upgrade',
    for: 'для продвинутых',
    image: 'python',
    price: 72855,
    cheap: [
      { text: '9 месяцев', colored: false },
      { text: 'ИИ', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Универсальный и легкий язык программирования',
      'Более глубокое погружение в среду',
      'Научитесь работать с библиотеками Python',
      'Создадите новый проект для портфолио',
    ],
  },
  {
    direction: DIRECTIONS.C,
    format: FORMATS.advanced,
    title: 'С++ Upgrade',
    for: 'для продвинутых',
    image: 'cplus',
    price: 72855,
    cheap: [
      { text: '9 месяцев', colored: false },
      { text: 'Программы', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Linux', colored: true },
      { text: 'Ubuntu', colored: true },
    ],
    textItems: [
      'Мощный язык программирования, используемый для создания высокопроизводительных приложений',
      'Научитесь работать с серверами Ubuntu',
      'Будете выстраивать сложную логику для собственных приложений',
      'Более глубоко погрузитесь во взаимодействие с Linux',
    ],
  },
  {
    direction: DIRECTIONS.roblox,
    format: FORMATS.advanced,
    title: 'Roblox Modeling',
    for: 'для продвинутых',
    image: 'roblox',
    price: 36000,
    cheap: [
      { text: '9 месяцев', colored: false },
      { text: 'Игры', colored: true },
      { text: 'Виртуальные миры', colored: true },
    ],
    textItems: [
      'Платформа для создания игр',
      'Научитесь моделировать и программировать на&nbsp;языке&nbsp;Lua',
      'Моделирование уровней и объектов, работа со&nbsp;светом и&nbsp;звуком ',
      'Вы познакомитесь с физикой объектов и анимацией, и&nbsp;научитесь выстраивать логику построения игры',
    ],
  },

  {
    direction: DIRECTIONS.python,
    format: FORMATS.advanced,
    title: 'Python Pro',
    for: 'для продвинутых',
    image: 'python',
    price: 97140,
    cheap: [
      { text: '12 месяцев', colored: false },
      { text: 'ИИ', colored: true },
      { text: 'Data Science', colored: true },
      { text: 'Базы данных', colored: true },
    ],
    textItems: [
      'Универсальный и легкий язык программирования',
      'Автоматизация повторяющихся задач: обработка данных, управление файлами',
      'Научитесь работать с реляционными базами данных',
      'Погрузитесь в Data Science и аналитику данных',
    ],
  },
  {
    direction: DIRECTIONS.javaScript,
    format: FORMATS.advanced,
    title: 'JavaScript Pro',
    for: 'для продвинутых',
    image: 'javaScript',
    price: 97140,
    cheap: [
      { text: '12 месяцев', colored: false },
      { text: 'Веб-анимация', colored: true },
      { text: 'Сайты', colored: true },
    ],
    textItems: [
      'Язык программирования для создания интерактивных элементов на сайте',
      // eslint-disable-next-line max-len,vue/max-len
      'Научитесь создавать проекты, используя основы JavaScript, HTML и&nbsp;CSS, а&nbsp;также фреймворки Angular и&nbsp;React',
      'Научитесь работать с библиотекой управления состоянием приложения Redux',
    ],
  },
  {
    direction: DIRECTIONS.roblox,
    format: FORMATS.advanced,
    title: 'Roblox PRO',
    for: 'для продвинутых',
    image: 'roblox',
    price: 48000,
    cheap: [
      { text: '12 месяцев', colored: false },
      { text: 'Игры', colored: true },
      { text: 'Виртуальные миры', colored: true },
    ],
    textItems: [
      'Платформа для создания игр',
      // eslint-disable-next-line max-len,vue/max-len
      'Вы научитесь выстраивать логику на всех этапах игры: начало, геймплей, условия победы, определения победителей, завершение и перезапуск игры',
      'Сможете улучшить игру, а также монетизировать ее и&nbsp;продвигать в интернете',
    ],
  },
  {
    direction: DIRECTIONS.java,
    format: FORMATS.advanced,
    title: 'Java Pro',
    for: 'для продвинутых',
    image: 'java',
    price: 97140,
    cheap: [
      { text: '12 месяцев', colored: false },
      { text: 'Программы', colored: true },
      { text: 'Мобильные приложения', colored: true },
    ],
    textItems: [
      'Язык программирования для разработки приложений, платформ и программ',
      'Начнете разработку Android-приложения на языке Kotlin',
      'Глубоко изучите объектно-ориентированное программирование',
      'Научитесь публиковать готовое приложение',
    ],
  },
  {
    direction: DIRECTIONS.C,
    format: FORMATS.advanced,
    title: 'С++ Pro',
    for: 'для продвинутых',
    image: 'cplus',
    price: 97140,
    cheap: [
      { text: '12 месяцев', colored: false },
      { text: 'Базы данных', colored: true },
      { text: 'NoSQL', colored: true },
    ],
    textItems: [
      'Мощный язык программирования, используемый для создания высокопроизводительных приложений',
      'Научитесь работать с анализом данных при помощи С++',
      'Особое внимание будет уделено работе с базами данных NoSQL',
    ],
  },

  {
    direction: DIRECTIONS.python,
    format: FORMATS.beginner,
    title: 'Python (будни)',
    for: 'вебинарный курс',
    image: 'python',
    price: 3090,
    cheap: [
      { text: '1 месяц', colored: false },
      { text: 'Базы данных', colored: true },
      { text: 'Игры', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Django', colored: true },
    ],
    textItems: [
      'Месячный курс из вебинаров в режиме онлайн',
      'Изучите синтаксис языка Python и азы объектно-ориентированного программирования',
      'Познакомитесь с функционалом Django, основами создания дизайна web-приложения',
      // eslint-disable-next-line max-len,vue/max-len
      'Поработаете с&nbsp;библиотеками Python, реляционными базами данных, Data Science и&nbsp;погрузитесь в&nbsp;аналитику данных',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.beginner,
    title: 'Python (выходные)',
    for: 'вебинарный курс',
    image: 'python',
    price: 4490,
    cheap: [
      { text: '1 месяц', colored: false },
      { text: 'Базы данных', colored: true },
      { text: 'Игры', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Django', colored: true },
    ],
    textItems: [
      'Месячный курс из вебинаров в режиме онлайн',
      'Изучите синтаксис языка Python и азы объектно-ориентированного программирования',
      'Познакомитесь с функционалом Django, основами создания дизайна web-приложения',
      // eslint-disable-next-line max-len,vue/max-len
      'Поработаете с&nbsp;библиотеками Python, реляционными базами данных, Data Science и&nbsp;погрузитесь в&nbsp;аналитику данных',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.advanced,
    title: 'Python (будни)',
    for: 'вебинарный курс',
    image: 'python',
    price: 12360,
    cheap: [
      { text: '4 месяца', colored: false },
      { text: 'Базы данных', colored: true },
      { text: 'Игры', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Django', colored: true },
    ],
    textItems: [
      'Курс состоит из 30 вебинаров в режиме онлайн',
      'Изучите Python, объектно-ориентированное программирование',
      'Познакомитесь с функционалом Django, основами создания дизайна web-приложения, введение в Docker',
      // eslint-disable-next-line max-len,vue/max-len
      'Поработаете с&nbsp;библиотеками Python, реляционными базами данных, Data Science, и&nbsp;погрузитесь в&nbsp;аналитику данных',
    ],
  },
  {
    direction: DIRECTIONS.python,
    format: FORMATS.advanced,
    title: 'Python (выходные)',
    for: 'вебинарный курс',
    image: 'python',
    price: 17960,
    cheap: [
      { text: '4 месяца', colored: false },
      { text: 'Базы данных', colored: true },
      { text: 'Игры', colored: true },
      { text: 'Веб-приложения', colored: true },
      { text: 'Django', colored: true },
    ],
    textItems: [
      'Курс состоит из 30 вебинаров в режиме онлайн',
      'Изучите Python, объектно-ориентированное программирование',
      'Познакомитесь с функционалом Django, основами создания дизайна web-приложения, введение в Docker',
      // eslint-disable-next-line max-len,vue/max-len
      'Поработаете с&nbsp;библиотеками Python, реляционными базами данных, Data Science, и&nbsp;погрузитесь в&nbsp;аналитику данных',
    ],
  },

  {
    direction: 'all',
    format: FORMATS.tutor,
    title: 'Репетиторство',
    for: '5 уроков',
    image: 'tutor',
    price: 7500,
    cheap: [
      { text: '8—13 лет', colored: false },
      { text: 'Любое направление', colored: true },
    ],
    textItems: [
      'Занятия с репетитором по любому языку программирования из каталога',
      'Акцент на важных аспектах и только нужные знания',
      'Опытные преподаватели с высоким уровнем экспертности',
      'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
    ],
  },
  {
    direction: 'all',
    format: FORMATS.tutor,
    title: 'Репетиторство',
    for: '5 уроков',
    image: 'tutor',
    price: 10000,
    cheap: [
      { text: '14—18 лет', colored: false },
      { text: 'Любое направление', colored: true },
    ],
    textItems: [
      'Занятия с репетитором по любому языку программирования из каталога',
      'Акцент на важных аспектах и только нужные знания',
      'Опытные преподаватели с высоким уровнем экспертности',
      'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
    ],
  },

  {
    direction: 'all',
    format: FORMATS.tutor,
    title: 'Репетиторство',
    for: '10 уроков',
    image: 'tutor',
    price: 13500,
    cheap: [
      { text: '8—13 лет', colored: false },
      { text: 'Любое направление', colored: true },
    ],
    textItems: [
      'Занятия с репетитором по любому языку программирования из каталога',
      'Более глубокое погружение в темы',
      'Опытные преподаватели с высоким уровнем экспертности',
      'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
    ],
  },
  {
    direction: 'all',
    format: FORMATS.tutor,
    title: 'Репетиторство',
    for: '10 уроков',
    image: 'tutor',
    price: 18000,
    cheap: [
      { text: '14—18 лет', colored: false },
      { text: 'Любое направление', colored: true },
    ],
    textItems: [
      'Занятия с репетитором по любому языку программирования из каталога',
      'Более глубокое погружение в темы',
      'Опытные преподаватели с высоким уровнем экспертности',
      'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
    ],
  },

  {
    direction: 'all',
    format: FORMATS.tutor,
    title: 'Репетиторство',
    for: '15 уроков',
    image: 'tutor',
    price: 18000,
    cheap: [
      { text: '8—13 лет', colored: false },
      { text: 'Любое направление', colored: true },
    ],
    textItems: [
      'Занятия с репетитором по любому языку программирования из каталога',
      'Прохождение сложных тем, глубокое погружение',
      'Опытные преподаватели с высоким уровнем экспертности',
      'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
    ],
  },
  {
    direction: 'all',
    format: FORMATS.tutor,
    title: 'Репетиторство',
    for: '15 уроков',
    image: 'tutor',
    price: 24000,
    cheap: [
      { text: '14—18 лет', colored: false },
      { text: 'Любое направление', colored: true },
    ],
    textItems: [
      'Занятия с репетитором по любому языку программирования из каталога',
      'Прохождение сложных тем, глубокое погружение',
      'Опытные преподаватели с высоким уровнем экспертности',
      'Индивидуальное расписание занятий с возможностью отмены и переноса без потери урока',
    ],
  },
];

export default cards;
